import React from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import ProductItem from "./components/ProductItem";

const cows = [
  {
    id: "fcow-1",
    name: "Cow 1",
    regNo: "XMRD",
    breed: "Jersey",
    dob: "25/11/2019",
    about:
      "Meet our cow Cow 1, the cherished companion of Farmer Name. She is a Jersey breed.",
    health:
      "Health Status: Excellent. Regular veterinary check-ups and a balanced diet ensure her well-being.",
    farmer:
      "Farmer: Farmer Name. Experienced in dairy farming for over 10 years, ensuring the best care for the cattle.",
    img: "img/cow1.png",
  },
  {
    id: "fcow-2",
    name: "Cow 2",
    regNo: "YZRD",
    breed: "Holstein",
    dob: "12/06/2020",
    about:
      "Meet our cow Cow 2, a strong and healthy member of our farm, known for her high milk yield and friendly nature.",
    health:
      "Health Status: Excellent. Monitored daily with premium nutrition for optimal health.",
    farmer:
      "Farmer: Farmer Name. Dedicated to sustainable dairy farming and top-notch animal care.",
    img: "img/cow2.png",
  },
];

const FarmersCattle = () => {
  const [storedName] = useLocalStorage("name", null);

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Farmer Name’s Cattle</h2>
      </div>

      {/* Intro */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                Discover the cattle cared for by our dedicated farmers. Explore their
                stories, health, and the people behind their well-being.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cow Profiles */}
      <div
        className="cw-slider-container"
        style={{ paddingTop: "29px", display: "flex", flexWrap: "wrap", gap: 20 }}
      >
        {cows.map((cow) => (
          <div
            key={cow.id}
            className="cw-container"
            style={{ flex: 1, minWidth: 300 }}
          >
            <div className="cw-image-section">
              <div className="cw-image-overlay"></div>
              <img src={cow.img} alt={cow.name} />
            </div>
            <div className="cw-content">
              <div className="cw-details">
                <h2>{cow.name}</h2>
                <p>Cattle Registration No: {cow.regNo}</p>
                <p>
                  Breed: {cow.breed} | DOB: {cow.dob}
                </p>
              </div>
              <div className="cw-tab-content active">
                <p>{cow.about}</p>
                <p>{cow.health}</p>
                <p>{cow.farmer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Traceability Journey */}
      <div className="wrapper2">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div>
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />
            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />
            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />
            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />
            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />
            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName || "You"}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmersCattle;

